var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupplierIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_51",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3124",
    "data-name": "Rectangle 3124",
    width: 34.312,
    height: 34.312,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9345",
    "data-name": "Group 9345",
    transform: "translate(8.991 6.459)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.99, -6.46)",
    filter: "url(#Ellipse_51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51-2",
    "data-name": "Ellipse 51",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11226",
    "data-name": "Group 11226",
    transform: "translate(26.008 25.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9218",
    "data-name": "Group 9218",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M34.307,19.684a4.434,4.434,0,0,0-.1-.928,3.546,3.546,0,0,0-1.131-1.888,3.628,3.628,0,0,0-1.418-.8,3.853,3.853,0,0,0-1.117-.132c-1.193,0-2.387,0-3.581,0a.37.37,0,0,1-.225-.029c.017-.054.031-.1.046-.151a3.477,3.477,0,0,0,.177-1.07q0-5.477,0-10.954a3.731,3.731,0,0,0-.171-1.168A3.737,3.737,0,0,0,25.76.971,3.617,3.617,0,0,0,24.3.133,3.947,3.947,0,0,0,23.164,0Q17.476,0,11.789,0c-.37,0-.74.012-1.109.038A3.835,3.835,0,0,0,9.241.46,3.324,3.324,0,0,0,8.526,1a3.4,3.4,0,0,0-1.17,2.626q-.009,5.466,0,10.933a3.587,3.587,0,0,0,.189,1.2c.015.045.023.094.041.161-.088,0-.156.008-.225.008-.976,0-1.953,0-2.929,0-.37,0-.74.012-1.109.038a3.737,3.737,0,0,0-1.422.414,3.6,3.6,0,0,0-1.09.92A3.383,3.383,0,0,0,0,19.581q0,5.448,0,10.9a4.106,4.106,0,0,0,.088.873,3.631,3.631,0,0,0,2.263,2.7,4.08,4.08,0,0,0,1.593.265q5.026,0,10.053,0c.325,0,.652-.008.975-.034a3.4,3.4,0,0,0,2.1-.852.724.724,0,0,1,.087-.061l.105.082a4.059,4.059,0,0,0,1.345.708,4.6,4.6,0,0,0,1.287.158q5,0,10,0c.376,0,.753-.012,1.128-.041A3.43,3.43,0,0,0,33.7,32.641a3.738,3.738,0,0,0,.609-2q0-5.475,0-10.953M15.785,31.17a1.184,1.184,0,0,1-.849.652,1.944,1.944,0,0,1-.436.043q-5.284,0-10.568,0a1.729,1.729,0,0,1-.818-.157,1.2,1.2,0,0,1-.621-.808,1.73,1.73,0,0,1-.046-.436q0-5.293,0-10.587a2.357,2.357,0,0,1,.061-.587,1.152,1.152,0,0,1,.946-.866,2.45,2.45,0,0,1,.474-.043c.272-.005.542,0,.831,0H13.6v0c.326,0,.652-.005.977,0a1.446,1.446,0,0,1,.716.176,1.181,1.181,0,0,1,.6.882,3.49,3.49,0,0,1,.035.5q0,5.207,0,10.414a1.8,1.8,0,0,1-.148.819M11.3,15.934a1.724,1.724,0,0,1-.836-.159,1.182,1.182,0,0,1-.629-.865,2.428,2.428,0,0,1-.038-.456q0-5.218,0-10.434a4.46,4.46,0,0,1,.04-.572,1.189,1.189,0,0,1,.969-.959,2.962,2.962,0,0,1,.475-.041c.594,0,1.19,0,1.785,0h3.547c.472-.008,1.074-.008,1.447,0H21.31c.6,0,1.206,0,1.809,0a1.485,1.485,0,0,1,.754.178,1.183,1.183,0,0,1,.6.883,2.969,2.969,0,0,1,.035.457q0,5.246,0,10.491a1.74,1.74,0,0,1-.148.781,1.184,1.184,0,0,1-.85.651,2.056,2.056,0,0,1-.456.043q-5.877,0-11.754,0M31.719,31.17a1.189,1.189,0,0,1-.849.652,1.95,1.95,0,0,1-.436.043q-5.284,0-10.569,0a1.721,1.721,0,0,1-.817-.156,1.206,1.206,0,0,1-.622-.809,1.727,1.727,0,0,1-.046-.435q0-5.3,0-10.606a2.246,2.246,0,0,1,.061-.568,1.151,1.151,0,0,1,.946-.867,2.443,2.443,0,0,1,.474-.043c.262-.005.526,0,.8,0h8.97v0c.291,0,.581,0,.872,0a1.44,1.44,0,0,1,.716.175,1.186,1.186,0,0,1,.6.883,2.968,2.968,0,0,1,.035.457q0,5.246,0,10.491a1.753,1.753,0,0,1-.147.781",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M139.89,23.946h0c-.118,0-.236,0-.354,0a1.03,1.03,0,0,0-.136.017v.22c0,.868,0,1.735,0,2.6,0,.325.005.649-.026.973a2.574,2.574,0,0,1-.31,1.053,2.4,2.4,0,0,1-1.105,1.047,2.9,2.9,0,0,1-1.139.2c-.708.017-1.417.013-2.125,0a3.606,3.606,0,0,1-.755-.091,2.433,2.433,0,0,1-1.4-.967,2.576,2.576,0,0,1-.462-1.567c-.011-1.086,0-2.17,0-3.255v-.235H135.2a6.87,6.87,0,0,0-.69.03c-.034.425-.017,3.5.02,3.652h2.434c.035-.392.019-3.528-.015-3.669-.056-.006-.163-.01-.3-.013Z",
    transform: "translate(-118.579 -21.5)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M46.616,179.936h.151v.234c0,.676-.006,1.352,0,2.029a2.907,2.907,0,0,0,.133.9,2.422,2.422,0,0,0,1.75,1.637,2.873,2.873,0,0,0,.736.087c1.116.009,2.234.013,3.35,0a2.836,2.836,0,0,0,1.14-.2,2.394,2.394,0,0,0,1.106-1.047,2.45,2.45,0,0,0,.306-1.034c.063-.783.012-1.568.031-2.351,0-.077,0-.153,0-.237a.684.684,0,0,1,.115-.021h.018v0Zm6.27,2.455H49.2v-2.443h3.682Z",
    transform: "translate(-41.855 -161.559)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M202.356,179.937h.178v.233c0,.677-.006,1.353,0,2.029a2.909,2.909,0,0,0,.132.9,2.427,2.427,0,0,0,1.75,1.637,2.883,2.883,0,0,0,.737.087c1.116.009,2.234.013,3.35,0a2.846,2.846,0,0,0,1.139-.2,2.4,2.4,0,0,0,1.107-1.047,2.459,2.459,0,0,0,.306-1.033c.063-.784.012-1.569.031-2.352,0-.076,0-.152,0-.237a.659.659,0,0,1,.114-.02h.124v0Zm6.3,2.455h-3.659l-.012-.011c0-.005-.01-.009-.01-.015a.461.461,0,0,1-.008-.076q0-1.14,0-2.279a.3.3,0,0,1,.015-.062h3.674Z",
    transform: "translate(-181.689 -161.56)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierIcon);
export default __webpack_public_path__ + "static/media/supplier-icon.fc68acc271e667b21ec1c7df58188c9b.svg";
export { ForwardRef as ReactComponent };